import React from "react";
import {Dropdown as BSDropdown, DropdownProps as BSDropdownProps} from "react-bootstrap";

import {Divider} from "@/components/divider/Divider.tsx";
import {DropdownHeader} from "@/components/dropdown/subComponents/DropdownHeader/DropdownHeader.tsx";
import {DropdownItem} from "@/components/dropdown/subComponents/DropdownItem/DropdownItem.tsx";
import {DropdownItemText} from "@/components/dropdown/subComponents/DropdownItemText/DropdownItemText.tsx";
import {DropdownMenu} from "@/components/dropdown/subComponents/DropdownMenu/DropdownMenu.tsx";
import {DropdownToggle} from "@/components/dropdown/subComponents/DropdownToggle/DropdownToggle.tsx";
import {PropsWithClassName} from "@/lib/types/props.ts";

type DropdownProps = BSDropdownProps & PropsWithClassName;

const DropdownComponent = React.forwardRef(({children, className = "", ...props}: DropdownProps, ref) => {
  return (
    <BSDropdown className={className} ref={ref} {...props}>
      {children}
    </BSDropdown>
  );
});

DropdownComponent.displayName = "Dropdown";

export const Dropdown = Object.assign(DropdownComponent, {
  Item: DropdownItem,
  Toggle: DropdownToggle,
  Menu: DropdownMenu,
  ItemText: DropdownItemText,
  Divider: Divider,
  Header: DropdownHeader,
});
